import { MutationCache, QueryCache, QueryClient } from 'react-query';
import { handleCommonError } from './handleCommonError';

export const createQueryClient = () =>
  new QueryClient({
    queryCache: new QueryCache({
      onError: handleCommonError,
    }),
    mutationCache: new MutationCache({
      onError: handleCommonError,
    }),
  });
